<template>
    <div class="card" v-show="loaded">

        <div class="card-header border-0">
            <div class="row">
                <div class="col">
                    <h3 class="mb-0 text-uppercase">{{ $t('common.learners') }}</h3>
                </div>
            </div>
        </div>

        <p class="card-body pt-0 text-sm" v-if="empty">{{ $t('dashboard.no-learner') }}</p>

        <div v-if="!empty">
            
            <table-control :paging="ctrl.paging" :search="true" v-model="search"></table-control>

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="ctrl.rows">

                <el-table-column width="72">
                    <template v-slot="{row}">
                        <a href="#" class="avatar rounded-circle" @click.prevent="open(row)">
                            <img :src="row.avatar">
                        </a>
                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">
                        <h4 class="mb-0">
                            <a href="#" @click.prevent="open(row)">
                                {{row.name}}
                            </a>
                        </h4>
                        <small v-if="row.owner">
                            {{ row.owner.name }}
                        </small>
                        <small v-if="row.entity">
                            / {{ row.entity.name }}
                        </small>
                    </template>
                </el-table-column>

                <el-table-column align="right" class-name="actions" width="120">
                    <template v-slot="{row}">
                        <div class="p-1">

                            <base-button type="primary" size="sm" @click="open(row)">
                                {{ $t('dashboard.follow-up') }}
                            </base-button>
                        </div>
                        
                    </template>
                </el-table-column>
                
            </el-table>

            <table-pagination :paging="ctrl.paging"></table-pagination>
        </div>
    </div>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import UserMapping from '../../accounts/users/UserMapping'

    export default {

        data() {
            let mapping = new UserMapping()
            return {
                loaded: false,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/users',
                    mapData: mapping.mapData,
                    unmapData: mapping.unmapData,
                    paging: {
                        perPage: 10,
                        total: 0
                    },
                    query: {
                        sort: ['lastname'],
                        relations: ['owner', 'entity'],
                        filters: { myLearners: true }
                    }
                }),
                search: '',
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
            })
        },

        watch: {
            search(val) {
                this.ctrl.filterMore({ simpleSearch: val })
            },
        },

        computed: {
            empty() {
                return this.ctrl.rows.length == 0 && !this.search
            },
        },

        methods: {            
            open(row) {
                this.$router.push({ name: 'dashboard-learner', params: { learnerId: row.id } })
            }
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .card >>> th.actions,
    .card >>> td.actions {
        padding-left: 0rem;
        padding-right: 1.5rem;
    }
    .card >>> .table-control form {
        width: 100%;
    }
    
</style>
